export default __webpack_public_path__ + "static/partner2-a3059a03400075d311eec0e94f6cd042.png";